import { c as _c } from "react/compiler-runtime";
import { useSubscribedCouponCollection } from './useSubscribedCouponCollection.js';
/**
 * Gets outcome array for given board and event.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @param root0.eventNumber Event number in the sequence
 * @param root0.groupIndex Event group index, mainly used for result
 * @param root0.boardIndex Used for multiple board bets, like SROW
 * @returns Coupon event outcomes array
 */
export function useCouponUserOutcomes(t0) {
  const $ = _c(8);
  const {
    couponId,
    couponIndex,
    boardIndex: t1,
    eventNumber,
    groupIndex
  } = t0;
  const boardIndex = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== boardIndex || $[1] !== couponIndex || $[2] !== eventNumber || $[3] !== groupIndex) {
    t2 = collection => {
      if (!collection) {
        return [];
      }
      if (couponIndex !== undefined) {
        const coupon = collection[couponIndex];
        if (!coupon) {
          return [];
        }
        const board = coupon.boards[boardIndex];
        if (!board) {
          return [];
        }
        if (groupIndex !== undefined && eventNumber) {
          return board.userOutcomes[eventNumber - 1]?.[groupIndex] || [];
        }
        if (eventNumber) {
          return board.userOutcomes[eventNumber - 1] || [];
        }
        return board.userOutcomes;
      }
      const [firstCoupon] = collection;
      if (!firstCoupon) {
        return [];
      }
      const [firstBoard] = firstCoupon.boards;
      if (!firstBoard) {
        return [];
      }
      return collection.map(coupon_0 => {
        const board_0 = coupon_0.boards[boardIndex];
        if (!board_0) {
          return [];
        }
        return board_0.userOutcomes;
      }).filter(_temp);
    };
    $[0] = boardIndex;
    $[1] = couponIndex;
    $[2] = eventNumber;
    $[3] = groupIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== couponId || $[6] !== t2) {
    t3 = {
      couponId,
      selector: t2
    };
    $[5] = couponId;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const outcomes = useSubscribedCouponCollection(t3);
  return outcomes;
}
function _temp(userOutcomes) {
  return userOutcomes.length > 0;
}